import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Clock } from 'lucide-react';
import ToolCard from '../shared/ToolCard';
import ErrorLogs from '../../Shared/ErrorLogs';
import AuthTimerTester from '../../Shared/IdleTimerTest';

const MonitoringTools = () => {
  const [selectedTool, setSelectedTool] = useState(null);

  const monitoringTools = [
    {
      id: 'errorLogs',
      icon: AlertTriangle,
      label: 'Error Logs',
      description: 'View and monitor system error logs and exceptions',
      action: 'View Logs'
    },
    {
      id: 'sessionTimer',
      icon: Clock,
      label: 'Session Management',
      description: 'Test idle timeout and session management features',
      action: 'Test Timer'
    }
  ];

  const handleToolClick = (tool) => {
    setSelectedTool(selectedTool === tool.id ? null : tool.id);
  };

  const renderToolContent = (toolId) => {
    switch (toolId) {
      case 'errorLogs':
        return (
          <div className="mt-6 bg-white dark:bg-gray-800 rounded-xl shadow-lg dark:shadow-gray-900/20 p-6">
            <ErrorLogs />
          </div>
        );
        
      case 'sessionTimer':
        return (
          <div className="mt-6 bg-white dark:bg-gray-800 rounded-xl shadow-lg dark:shadow-gray-900/20 p-6">
            <AuthTimerTester />
          </div>
        );
        
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {monitoringTools.map((tool) => (
          <ToolCard
            key={tool.id}
            tool={tool}
            onClick={handleToolClick}
            className={selectedTool === tool.id ? 'ring-2 ring-primary-500' : ''}
          />
        ))}
      </div>

      {/* Render selected tool content */}
      {selectedTool && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="overflow-hidden"
        >
          {renderToolContent(selectedTool)}
        </motion.div>
      )}
    </div>
  );
};

export default MonitoringTools;
